'use client'

import { useRouter } from 'next/navigation'
import { useState } from 'react'

export function JoinCommunityButton({
  sellerId,
  approvalRequired,
  tag = '',
  onJoined,
}: {
  sellerId: number
  approvalRequired: boolean
  tag?: string
  onJoined?: (status: 'approved' | 'pending') => void
}) {
  const router = useRouter()
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)

  async function join() {
    setErr(null)
    setBusy(true)

    try {
      const res = await fetch('/api/community/join', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          seller_id: sellerId,
          tag,
        }),
      })

      const data = await res.json().catch(() => null)

      if (!res.ok) {
        throw new Error(data?.error || 'join_failed')
      }

      const status =
        data?.status === 'approved'
          ? 'approved'
          : 'pending'

      if (onJoined) {
        onJoined(status)
        return
      }

      router.refresh()

      if (data?.status === 'approved') {
        setTimeout(() => {
          window.dispatchEvent(
            new Event('hubee:community-joined')
          )
        }, 350)
      }
    } catch (e: any) {
      setErr(e?.message || 'join_failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="space-y-2">
      <button
        type="button"
        onClick={join}
        disabled={busy}
        className="h-11 rounded-xl px-5 font-semibold bg-foreground text-background disabled:opacity-60"
      >
        {busy ? 'Uniéndome…' : 'Unirme a la comunidad'}
      </button>

      {err ? <div className="text-sm text-red-500">{err}</div> : null}
    </div>
  )
}